import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as profileActions from '@/store/modules/myAccount';
import { authenticationService } from '@/services/authentication_service';

export type UserProfilePropsT = {
    first_name?: string;
    city?: string;
    data_filled?: boolean;
    contact_no?: string;
    membership: {
        is_gold_member: boolean;
        car_revive_booked: boolean;
        fastag: {
            issued: boolean;
        };
    };
};

export default function useProfileData() {
    const dispatch = useDispatch();
    const { userProfile, updatingData } = useSelector((state: any) => ({
        userProfile: state?.myAccount?.profileData as UserProfilePropsT,
        updatingData: state?.myAccount?.updatingData,
    }));

    const [userInitials, setUserInitials] = useState<string>('');
    const isLoggedIn = authenticationService.isLoggedIn();

    useEffect(() => {
        if (isLoggedIn) {
            if (
                userProfile &&
                localStorage &&
                userProfile.contact_no === localStorage.getItem('mobileNumber')
            ) {
                if (userProfile.first_name) {
                    const nameArray = userProfile.first_name?.split(' ');
                    const initials = nameArray[1]
                        ? nameArray?.[0][0] + nameArray?.[1][0]
                        : nameArray?.[0][0];
                    setUserInitials(initials);
                }
            } else if (!updatingData) {
                dispatch(profileActions.fetchProfileData());
            }
        }
    }, [JSON.stringify(userProfile)]);

    return userInitials;
}
